export default "__VITE_ASSET__DFO7MfCi__"